import type { IComponentController } from "angular";

export class TagComponentController implements IComponentController {
    public static $inject: string[] = [];
}
